import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The Vitally connector can link accounts, conversations, notes, tasks, and more to PostHog.`}</p>
    <p>{`To link Vitally:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Go to the `}<a parentName="p" {...{
            "href": "https://us.posthog.com/pipeline/sources"
          }}>{`sources tab`}</a>{` of the data pipeline section in PostHog.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`+ New source`}</strong>{` and then click `}<strong parentName="p">{`Link`}</strong>{` next to Vitally.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Next, you need a secret token from Vitally. To start, click on your account logo in the top left, then `}<strong parentName="p">{`Settings`}</strong>{`. Next, under `}<strong parentName="p">{`Operations`}</strong>{`, select `}<strong parentName="p">{`Integrations`}</strong>{`. Choose `}<strong parentName="p">{`Vitally REST API`}</strong>{`, enable the integration with the toggle, and copy the secret token.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Back in PostHog, paste the token in the `}<inlineCode parentName="p">{`Secret token`}</inlineCode>{` field, choose your Vitally region, and add a prefix for your tables if you want. Once all this is entered, click `}<strong parentName="p">{`Save`}</strong>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`On the next page, set up the schemas you want to sync and modify the method and frequency as needed. Once done, click `}<strong parentName="p">{`Import`}</strong>{`.`}</p>
      </li>
    </ol>
    <p>{`Once the syncs are complete, you can start using Vitally data in PostHog.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      